const yup = require('yup')

const displayLocation = () =>
  yup
    .string()
    .oneOf(['signage', 'mobile', 'both'])
    .default('both')

module.exports = displayLocation
